import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import {
  MDBContainer,
  MDBCol,
  MDBRow,
  MDBBtn,
  MDBInput,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
} from 'mdb-react-ui-kit';

const ChangePassword = () => {
  const { state } = useLocation();
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const userId = state?.userId;

    useEffect(() => {
      // Get the token from sessionStorage
  
  
      if (!userId) {
        navigate('/login');
        return;
      }
  
    }, []);
  

  const handleChangePassword = async (e) => {
    e.preventDefault();

    try {
      
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/changePassword`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId, newPassword }),
      });

      if (response.ok) {

        navigate('/login');  

      } else {
        const data = await response.json();
        setError(data.message);
      }
    } catch (err) {
      setError('An error occurred. Please try again later.');
    }
  };

  return (
    <MDBContainer className="my-5">
      <MDBRow className="justify-content-center">
        <MDBCol md="6">
          <MDBCard>
            <MDBCardHeader className="text-center">
              <h4>ตั้งรหัสผ่านใหม่</h4>
            </MDBCardHeader>
            <MDBCardBody>
              {error && (
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
              )}
              <form onSubmit={handleChangePassword}>
               
                <MDBInput
                  label="รหัสผ่านใหม่"
                  id="password"
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  className="mb-4"
                  required
                />
                <div className="d-grid">
                  <MDBBtn type="submit" color="primary">
                    เปลี่ยนรหัสผ่าน
                  </MDBBtn>
                </div>
              </form>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  );
};

export default ChangePassword;
